import { render, staticRenderFns } from "./UploadSignedQuestion.vue?vue&type=template&id=741ee937"
import script from "./UploadSignedQuestion.vue?vue&type=script&lang=js"
export * from "./UploadSignedQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports